var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo-img",attrs:{"src":_vm.logo,"alt":"Nummer gegen Kummer Mail-Beratung"}})}
var staticRenderFns = []

export { render, staticRenderFns }